// extracted by css-extract-rspack-plugin
export default {"search":"Search-module__search--zFH6_","black-background":"Search-module__black-background--umwkd"};